const SignButton = ({ text }) => {
  return (
    <div className="sign-form__button__wrapper">
      <button className="sign-form__button">{text}</button>
    </div>
  );
};

export default SignButton;
